import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, track, trackPageView } from '../lib/analytics';

let lastTracked = null;

const labelFor = (el) =>
  el.dataset.label || (el.getAttribute('aria-label') || el.textContent || '').trim().slice(0, 80);

// Fires page_view on every route change and captures declarative + outbound clicks.
const AnalyticsTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (lastTracked === pathname) return undefined; // StrictMode double-invoke / re-mount guard
    const initial = lastTracked === null;
    lastTracked = pathname;
    if (initial) initAnalytics();
    // Wait a tick so react-helmet has set the document title for this route
    const t = setTimeout(() => trackPageView(pathname, { initial }), 50);
    return () => clearTimeout(t);
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const tagged = e.target.closest('[data-analytics]');
      if (tagged) track(tagged.dataset.analytics, { label: labelFor(tagged) });
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      if (/^https?:\/\//.test(href) && !href.startsWith(window.location.origin)) {
        track('outbound_click', { label: href, link_text: labelFor(a) });
      } else if (a.closest('header') && !tagged) {
        track('nav_click', { label: labelFor(a), href });
      }
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
};

export default AnalyticsTracker;
